import { ListboxSelected } from '@/components/Listbox';
import { useTableLabelsOnMount } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/components/BroadcastScheduleProgramBodySegmentToolkitLogotipos/context/BroadcastScheduleProvider';
import { LogoCatalogueListbox } from '@/features/logos/components/LogoCatalogueListbox';

type LogoInlineDropdownProps = {
  onChange: (value: ListboxSelected) => void;
};

export function LogoSelectionDropdown({ onChange }: LogoInlineDropdownProps) {
  const labelsFilter = useTableLabelsOnMount();

  return <LogoCatalogueListbox mode="single" onChange={onChange} labelsFilter={labelsFilter} />;
}
